// Generated by purs version 0.13.8
"use strict";
var Control_Category = require("../Control.Category/index.js");
var Control_Monad_Free = require("../Control.Monad.Free/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var UIAction = (function () {
    function UIAction(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    UIAction.create = function (value0) {
        return function (value1) {
            return new UIAction(value0, value1);
        };
    };
    return UIAction;
})();
var UIAwaitingInput = (function () {
    function UIAwaitingInput(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    UIAwaitingInput.create = function (value0) {
        return function (value1) {
            return new UIAwaitingInput(value0, value1);
        };
    };
    return UIAwaitingInput;
})();
var input = function (ui) {
    return Control_Monad_Free.liftF(new UIAwaitingInput(ui, Control_Category.identity(Control_Category.categoryFn)));
};
var functorUIF = new Data_Functor.Functor(function (f) {
    return function (m) {
        if (m instanceof UIAction) {
            return new UIAction(m.value0, Data_Functor.map(Data_Functor.functorFn)(f)(m.value1));
        };
        if (m instanceof UIAwaitingInput) {
            return new UIAwaitingInput(m.value0, Data_Functor.map(Data_Functor.functorFn)(f)(m.value1));
        };
        throw new Error("Failed pattern match at Framework.UI (line 11, column 1 - line 11, column 60): " + [ m.constructor.name ]);
    };
});
var getUIState = function (uim) {
    var v = Control_Monad_Free.resume(functorUIF)(uim);
    if (v instanceof Data_Either.Right) {
        return Data_Maybe.Nothing.value;
    };
    if (v instanceof Data_Either.Left && v.value0 instanceof UIAction) {
        return Data_Maybe.Nothing.value;
    };
    if (v instanceof Data_Either.Left && v.value0 instanceof UIAwaitingInput) {
        return new Data_Maybe.Just(v.value0.value0);
    };
    throw new Error("Failed pattern match at Framework.UI (line 29, column 18 - line 32, column 39): " + [ v.constructor.name ]);
};
var action = function (a) {
    return Control_Monad_Free.liftF(new UIAction(a, Control_Category.identity(Control_Category.categoryFn)));
};
module.exports = {
    UIAction: UIAction,
    UIAwaitingInput: UIAwaitingInput,
    input: input,
    action: action,
    getUIState: getUIState,
    functorUIF: functorUIF
};
